// Author Pan Yu Rou
// Date 2022-10-28 16:48:01

import * as model from "@/model/sithMes/prd/SithMesPrdInfoRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdInfoRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'subviewVo'
    })
    .buildStore()
